import {
  ConfigureSaleTaxBy,
  TDomesticTable,
  TInternationalTable,
  ZipCodeType,
} from '@src/types/feeSettings.ts';
import { TOption } from '@src/types';

export const domesticTaxData: TDomesticTable[] = [
  {
    id: 1,
    stateZipCode: '000024',
    taxRate: 0.05,
    applyTaxToShipping: 'Apply tax to shipping',
    status: true,
  },
  {
    id: 2,
    stateZipCode: '000024',
    taxRate: 0.05,
    applyTaxToShipping: 'Apply tax to shipping',
    status: true,
  },
  {
    id: 3,
    stateZipCode: '000024',
    taxRate: 0.05,
    applyTaxToShipping: 'Apply tax to shipping',
    status: true,
  },
  {
    id: 4,
    stateZipCode: '000024',
    taxRate: 0.05,
    applyTaxToShipping: 'Apply tax to shipping',
    status: true,
  },
];

export const internationalTaxData: TInternationalTable[] = [
  {
    id: 1,
    country: 'Ha noi',
    taxRate: 0.05,
    applyTaxToShipping: 'Apply tax to shipping',
    status: true,
  },
  {
    id: 2,
    country: 'Ha noi',
    taxRate: 0.05,
    applyTaxToShipping: 'Apply tax to shipping',
    status: true,
  },
  {
    id: 3,
    country: 'Ha noi',
    taxRate: 0.05,
    applyTaxToShipping: 'Apply tax to shipping',
    status: true,
  },
  {
    id: 4,
    country: 'Ha noi',
    taxRate: 0.05,
    applyTaxToShipping: 'Apply tax to shipping',
    status: true,
  },
];

export const configureSalesTaxData: TOption[] = [
  { label: 'State', value: ConfigureSaleTaxBy.State },
  { label: 'Zip Code', value: ConfigureSaleTaxBy.ZipCode },
];

export const zipCodeData: TOption[] = [
  { label: 'Specific', value: ZipCodeType.Specific },
  { label: 'Range', value: ZipCodeType.Range },
];

export const StateOptions: TOption[] = [
  { label: 'Alabama', value: 'alabama' },
  { label: 'Alaska', value: 'alaska' },
  { label: 'Arizona', value: 'arizona' },
  { label: 'Arkansas', value: 'arkansas' },
  { label: 'California', value: 'california' },
  { label: 'Colorado', value: 'colorado' },
];
